var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgerTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n      fill: #757575;\r\n      stroke: #fff;\r\n      stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15,-8) scale(1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.5,53h-5l-1-1,1-1,.5-.5,1.5-.5,1.5-1.5,1-2v-1l-2.5-1.5-1.5-2-3-2-2.5-1-3,.5h-2l-1-1-.5-.5-.5-.5v-1l1.5-.5,4-4.5,4.5-1,2-1,.5,1.5,6.5-.5,3.5-1,3-.5,5.5-1.5h6l4.5,1,4,2.5,2,4,2.5,7.5,3,5.5,2,2-1,1-3-.5-4-5-2,6.5h-4l-1-.5,.5-1,1.5-1-1.5-3.5v.5l-3.5,5.5h-3l-1.5-1,1-1,1-1,1.26-3h-9.76l.5,4.5-2,2-3.5,.5-1.5-1,1.5-1.5,1.5-.5,.5-2-1.5-1.5-.5,1-1,2.5-1.5,.5-1.5,2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgerTooltip);
export default __webpack_public_path__ + "static/media/badger_tooltip.f180a9e9b05cc83f700407f13473c63e.svg";
export { ForwardRef as ReactComponent };